import React, { useEffect, useState } from 'react';
import Tag from '~/modules/addListing/pages/DetailsStep/Tag';
import { addListingDetailsType, ListingDetailsType } from '~addListing/types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PAYMENT_METHOD_CASH_AND_INSTALLMENT_KEY } from '~addListing/utils/data';

const PaymentMethod = ({
  customFieldsData,
  listing,
}: {
  customFieldsData: { paymentMethod: { value: string; key: number }[] };
  listing: ListingDetailsType;
}) => {
  const { t } = useTranslation('app');
  const isForSale = listing?.section?.slug === 'for-sale';
  const [selectedTag, setSelectedTag] = useState<number | null>(null);
  const defaultPaymentMethod = listing?.payment_method || null;

  const {
    setValue,
    formState: { errors },
    clearErrors,
  } = useFormContext<addListingDetailsType>();

  const handleSelectPaymentMethod = (key: number) => {
    setSelectedTag(key);
    setValue('paymentMethod', key);
    clearErrors('paymentMethod');
  };

  useEffect(() => {
    setSelectedTag(listing?.payment_method);
    setValue('paymentMethod', listing?.payment_method);
  }, []);

  useEffect(() => {
    handleSelectPaymentMethod(
      defaultPaymentMethod ?? PAYMENT_METHOD_CASH_AND_INSTALLMENT_KEY,
    );
  }, [defaultPaymentMethod]);

  const orderedPaymentMethods = [...customFieldsData.paymentMethod].sort(
    (a, b) =>
      a.key === PAYMENT_METHOD_CASH_AND_INSTALLMENT_KEY
        ? -1
        : b.key === PAYMENT_METHOD_CASH_AND_INSTALLMENT_KEY
          ? 1
          : 0,
  );

  if (!isForSale) return null;

  return (
    <div className="flex flex-col gap-2x">
      <p className="text-title_4 text-black">{t('paymentMethod')}</p>
      <div className="flex flex-wrap gap-1.5x">
        {orderedPaymentMethods.map((tag) => (
          <Tag
            key={tag.key}
            text={tag.value}
            isSelected={selectedTag === tag.key}
            onClick={() => handleSelectPaymentMethod(tag.key)}
            className={
              errors.paymentMethod ? '!border-red_dark' : '!border-gray'
            }
          />
        ))}
      </div>
      {errors.paymentMethod && (
        <p className="text-red_dark text-body_2">
          {t('paymentMethodRequired')}
        </p>
      )}
    </div>
  );
};

export default PaymentMethod;
